import { PreMatch } from 'features/eventPreMatch/container/sportPrematch.component';
import { useParams } from 'react-router-dom';
import { CacheView } from 'shared/components/CacheView';

const PreMatchWrapper = () => {
	const params = useParams<{ id: string }>();
	return (
		<CacheView cacheKey={'event-prematch'} cacheKeyId={params.id}>
			<PreMatch />
		</CacheView>
	);
};

export default PreMatchWrapper;
